import { render, staticRenderFns } from "./Test22.vue?vue&type=template&id=c91577aa&scoped=true&"
import script from "./Test22.vue?vue&type=script&lang=js&"
export * from "./Test22.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./Test22.vue?vue&type=style&index=1&id=c91577aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91577aa",
  null
  
)

export default component.exports